export default __webpack_public_path__ + "static/media/property_311.19bad3de.png";